module.exports = __webpack_public_path__ + "static/media/caret.f39e1f8f.svg";